import { useState } from 'react';
import { TerminalBlock } from '@/components/blocks/TerminalBlock';
import { NotionBlock } from '@/components/blocks/NotionBlock';
import { SPABlock } from '@/components/blocks/SPABlock';
import { MLGraphBlock } from '@/components/blocks/MLGraphBlock';
import { DeploymentBlock } from '@/components/blocks/DeploymentBlock';
import './index.css';

export function App() {
  const [snowActive, setSnowActive] = useState(false);
  const [deploymentTriggered, setDeploymentTriggered] = useState(false);

  const handleCloseDeployment = () => {
    setDeploymentTriggered(false);
  };

  const handleMlComplete = () => {
    setDeploymentTriggered(true);
  };

  return (
    <div className="relative bg-[#1E1E1E]">
      {/* Terminal - Hero Section */}
      <TerminalBlock onDeploy={() => {}} />

      {/* Notion - The Notion of Life */}
      <NotionBlock />

      {/* SPA - Interactive Recovery */}
      <SPABlock
        snowActive={snowActive}
        onToggleSnow={() => setSnowActive(!snowActive)}
      />

      {/* ML Graph - Training Log */}
      <MLGraphBlock onNext={handleMlComplete} />

      {/* Deployment Modal */}
      {deploymentTriggered && (
        <DeploymentBlock onClose={handleCloseDeployment} />
      )}
    </div>
  );
}

export default App;

